import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material";
import { AppService } from "../../../../../services/app.service";

@Component({
  selector: 'atyl-text-banner',
  templateUrl: './text-banner.component.html',
  styleUrls: ['./text-banner.component.scss']
})
export class AtylTextBannerComponent implements OnInit {
  showBanner: boolean = true;
  loading: boolean = false;
  message: string = "";
  link: any = null;
  
  mentions: any=null; 
  rgpd: any = null;
  cookie: any = null;
  
   @Input() messages :any={
		SANITAIRE: {
			message:null,
			link:null
		},
		MENTIONS_LEGALES: {
			message:null,
			link:null
		},
		COOKIES: {
			message:null,
			link:null
		},
		RGPD: {
			message:null,
			link:null
		},
		OPENID: {
			message:null,
			link:null
		}
		
	};
  
  @Input() position: string = 'bottom';
  subscribeList = [];
  constructor(
    private _snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private appService: AppService
  ) { }

  ngOnInit() {
   /*
    this.subscribeList.push(
      this.appService.accueil().subscribe(res => {
        if (res.result) {
          let messages= res.result; 
          if (messages.SANITAIRE!=undefined) {
              if (messages.SANITAIRE.message!=undefined)  
                this.message = messages.SANITAIRE.message;
              if (messages.SANITAIRE.link!=undefined)  
                this.link = messages.SANITAIRE.link;
          }
          if (messages.MENTIONS_LEGALES!=undefined) {
            this.mentions=messages.MENTIONS_LEGALES;
          }
          if (messages.COOKIES!=undefined) {
            this.cookie=messages.COOKIES;
          }
          if (messages.RGPD!=undefined) {
            this.rgpd=messages.RGPD;
          }
          console.log("messsage",this.mentions, this.cookie,this.rgpd);
          this.loading = false;
          this.changeDetectorRef.detectChanges();
        }
      })
    );
    */
  }

  hideTextBanner() {
    this.showBanner = !this.showBanner;
  }


}
